const to_display_time = (val: number) => {
  const hour = Math.floor(val / 3600)
  let hour_str
  if (hour < 10) {
    hour_str = `0${hour}`
  } else {
    hour_str = String(hour)
  }

  const minute = Math.floor((val - (hour * 3600)) / 60)
  let minute_str
  if (minute < 10) {
    minute_str = `0${minute}`
  } else {
    minute_str = String(minute)
  }
  return `${hour_str}:${minute_str}`
}

export const chartOptions = {
  chart: {
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      distributed: false,
      horizontal: false,
      dataLabels: {
        position: 'top',
      },
    },
  },
  dataLabels: {
    enabled: true,
    offsetY: -20,
    distributed: false,
    formatter: (val: number): string => to_display_time(val),
    style: {
      colors: ["#333333", "#C4C4C4"],
    },
  },
  xaxis: {
    categories: [""],
    labels: {
      style: {
        fontSize: '10px',
      },
    },
  },
  yaxis: {
    showForNullSeries: false,
    labels: {
      formatter: (val: number): string => to_display_time(val),
      maxWidth: "10px",
    },
  },
  states: {
    hover: {
      filter: 'none',
    },
  },
  legend: {
    show: false,
  },
  tooltip: {
    enabled: false,
  },
  colors: [],
}

export default chartOptions
